import React from 'react'

function Login() {
  return (
    <div>Login</div>
  )
}

export default Login